"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { Reader } from "@/lib/reader";
import { subscribeToReader } from "@/lib/session-reader";
export function useSessionReader() {
  const $ = _c(2);
  const [reader, setReader] = useState();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => subscribeToReader(setReader);
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return reader;
}